import { Pipe, type PipeTransform } from '@angular/core'

@Pipe({
  name: 'arrayContains',
  standalone: true,
})
export class ArrayContainsPipe implements PipeTransform {
  transform (list: unknown[], element: unknown): boolean {
    return list.includes(element)
  }
}
